<template>
    <div class="inline-flex">
        <div
            :class="`font-headings ${sizeClasses} rounded-full font-bold text-${variant}-500 bg-white border-2 border-${variant}-500 flex gap-4 items-center group hover:bg-${variant}-50 hover:shadow transition-colors duration-300 cursor-pointer`">
            <div>{{ text }}</div>
            <div v-if="hasArrow"
                :class="`${sizeClassesForCircle} bg-${variant}-500 rounded-full text-white`">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" :class="sizeClassesForArrow"
                    class="group-hover:rotate-45 transition-transform duration-300">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    text: {
        type: String,
        required: true
    },
    variant: {
        type: String,
        required: true,
        default: 'primary',
        validator: (value) => {
            return ['primary', 'secondary', 'accent'].includes(value)
        }
    },
    hasArrow: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        required: true,
        default: 'md',
        validator: (value) => {
            return ['sm', 'md', 'lg'].includes(value)
        }
    }
})

const sizeClasses = computed(() => {
    switch (props.size) {
        case 'sm':
            return 'py-1 pl-6 text-sm' + (props.hasArrow ? ' pr-2' : ' pr-6');
        case 'lg':
            return 'py-2 pl-8 text-' + (props.hasArrow ? ' pr-2' : ' pr-6');
        default:
            return 'py-2 px-6 text-base' + (props.hasArrow ? ' pr-2' : ' pr-6');
    }
})

const sizeClassesForArrow = computed(() => {
    switch (props.size) {
        case 'sm':
            return 'w-4 h-4'        
        case 'lg':
            return 'w-7 h-7'
        default:
            return 'w-5 h-5'
    }
})

const sizeClassesForCircle = computed(() => {
    switch (props.size) {
        case 'sm':
            return 'w-6 h-6 p-1'        
        case 'lg':
            return 'w-10 h-10 p-1.5'
        default:
            return 'w-8 h-8 p-1.5'
    }
})



</script>